$(document).ready(function() {
  // Mobile nav drawer
  const navToggle = document.getElementById('nav-toggle');
  const navDrawer = document.getElementById('nav-drawer');
  const navOverlay = document.getElementById('nav-overlay');
  const navClose = document.getElementById('nav-close');

  function openDrawer() {
    navDrawer.classList.add('is-open');
    navOverlay.classList.add('is-visible');
    navDrawer.setAttribute('aria-hidden', 'false');
    navOverlay.setAttribute('aria-hidden', 'false');
    navToggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('nav-open');
    navClose.focus();
  }

  function closeDrawer() {
    navDrawer.classList.remove('is-open');
    navOverlay.classList.remove('is-visible');
    navDrawer.setAttribute('aria-hidden', 'true');
    navOverlay.setAttribute('aria-hidden', 'true');
    navToggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('nav-open');
    navToggle.focus();
  }

  if (navToggle) {
    navToggle.addEventListener('click', openDrawer);
  }
  if (navClose) {
    navClose.addEventListener('click', closeDrawer);
  }
  if (navOverlay) {
    navOverlay.addEventListener('click', closeDrawer);
  }
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && navDrawer && navDrawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  // Sub-menu toggles inside drawer
  if (navDrawer) {
    navDrawer.querySelectorAll('li.menu-item-has-children').forEach(function(item) {
      const link = item.querySelector(':scope > a');
      const subMenu = item.querySelector(':scope > .sub-menu');
      if (!link || !subMenu) return;

      const btn = document.createElement('button');
      btn.className = 'sub-menu-toggle';
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-label', 'Раскрыть подменю');
      item.appendChild(btn);

      btn.addEventListener('click', function() {
        const isOpen = subMenu.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }
});